const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the smart card component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Articles} Articles the resource defined to manage Articles
 * @argument {Files} Files the resource defined to manage Files
 * @argument {Videos} Videos the resource defined to manage Videos
 * @argument {Events} Events the resource defined to manage Events
 * @argument {Tracks} Tracks the resource defined to manage Tracks
 */
app.directive('smartCard', ['Application', 'Authorization', 'Articles', 'Files', 'Videos', 'Events', 'Tracks', 'Polls', 'ScormContent', 'Presentations', 'ImportedContent', 'Analyze', '$filter', '$translate', function (Application, Authorization, Articles, Files, Videos, Events, Tracks, Polls, ScormContent, Presentations, ImportedContent, Analyze, $filter, $translate) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      contentType: '@',
      contentId: '@',
      fullData: '=',
      isFirst: '@',
      previewWatch: '@',
      metaData: '=',
      userClick: '&',
      index: '=?',
      isList: '=?',
      searchTerm: '=?'
    },
    template: require('../../templates/directives/smart-card.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.fetchedDescription = null;

      self.trackTrim = null;
      self.first = $scope.isFirst === 'true' ? true : false;

      self.isList = ($scope.isList === true ? $scope.isList : false);
      self.isListTop = false ;
      self.isNewList = self.isList;
      self.isDedicatedWorkshop = Application.features.flags().dedicated_workshops

      self.translations = {};

      self.getStars = function() {
        if (!self.content || !self.content.average_rating || !self.content.rating_configuration?.show_users_rating) {
          return null;
        }

        var outOfFive = Math.round(self.content.average_rating / 10 * 5) / 10;
        if (outOfFive) {
          return outOfFive;
        }

        return null;
      };

      var getContent = function(contentType, contentId, description) {
        switch (contentType) {
          case 'article':
            return Articles.get({
              subresource: contentId,
              fields: description ? 'content' : 'title,image,author,duration,cover_justification,featured_justification,average_rating'
            }).$promise;
            break;
          case 'file':
            return Files.get({
              subresource: contentId,
              fields: description ? 'description' : 'title,author,duration,images,cover_justification,featured_justification,average_rating'
            }).$promise;
            break;
          case 'video':
            return Videos.get({
              subresource: contentId,
              fields: description ? 'description' : 'title,author,duration,images,cover_justification,featured_justification,average_rating'
            }).$promise;
            break;
          case 'event':
            return Events.get({
              subresource: contentId,
              fields: description ? 'description' : 'title,hosts,image,description,start_date,location,online_location,cover_justification,featured_justification'
            }).$promise;
            break;
          case 'track':
            return Tracks.get({
              subresource: contentId,
              fields: description ? 'description' : 'name,topic,creator_name,creator_bio,creator_image,creator_link,images,duration,description,cover_justification,featured_justification,resource,average_rating'
            }).$promise;
            break;
          case 'scorm':
            return ScormContent.get({
              subresource: contentId,
              fields: description ? 'description' : 'title,author,duration,package_duration,typical_time,description,image,banner_image,cover_justification,featured_justification,average_rating'
            }).$promise;
            break;
          case 'presentation':
            return Presentations.get({
              subresource: contentId,
              fields: description ? 'description' : 'title,author,published,image,cover_justification,featured_justification'
            }).$promise;
            break;
          case 'poll':
            return Polls.get({
              subresource: contentId,
              fields: 'question,answers,users_responded,response_copy,show_results,anonymous_results,results_a,results_b,results_c,results_d,results_e'
            }).$promise;
            break;
          case 'workshop':
            return Polls.get({
              subresource: contentId,
              fields: description ? 'description' : 'title,image,cover_justification,featured_justification,single_date,multiple_dates'
            }).$promise;
            break;
          case 'imported_content':
            return ImportedContent.get({
              subresource: contentId,
              fields: description ? 'content' : 'title,image,instructors,duration,cover_justification,featured_justification,average_rating'
            }).$promise;
            break;
          default:
            return;
        }
      };

      self.getTextType = function (type){
        if (self.contentType === 'imported_content'){
          return self.content.vendor;
        } else {
          return type;
        }
      };

      self.image = function (tile) {
        var imgPlaceholder = '';
        var applyStyle = function(image) {
          if (!image) {
            return {};
          };
          let imageUrl;
          const height = !self.isList ? '800' : '150';
          let width;
          let c;
          const ratio = 2.5;
          if (!self.isList) {
            width =  '580';
            c = 'fit';
          } else {
            width = '280';
            c = 'fill';
          }

          imageUrl = `https://res.cloudinary.com/continu/image/fetch/w_${parseInt(width,10) * ratio},h_${parseInt(height,10) * ratio},c_${c},f_auto,q_auto/${image}`;
          return {
            'background-image': 'url(' + imageUrl+ ')'
          };
        };

        if (!tile) {
          return applyStyle(imgPlaceholder);
        }

        if ($scope.contentType === 'user') {
          var userBackground = 'https://d2277n3gvptnup.cloudfront.net/images/9854c3b4-cb4d-473b-86bf-50b8c700e285.jpeg'
          return applyStyle(userBackground);
        }

        var image = tile.images || tile.image || tile.banner_image;
        if (self.contentType === 'scorm') {
          image = tile.image || tile.banner_image;
        }
        if (image === null) {
          return applyStyle(imgPlaceholder);
        }
        if (typeof image === 'string' && image !== "") {
          return image.indexOf('/img/') === -1 ? applyStyle(image) : applyStyle(imgPlaceholder);
        }
        if (typeof image === 'object' && image.medium) {
          return image.medium.indexOf('/img/') === -1 ? applyStyle(image.medium) : applyStyle(imgPlaceholder);
        }
        if (typeof image === 'object' && image.explore) {
          return image.explore.indexOf('/img/') === -1 ? applyStyle(image.explore) : applyStyle(imgPlaceholder);
        }
        if (typeof image === 'object' && image.custom) {
          return image.custom.indexOf('/img/') === -1 ? applyStyle(image.custom) : applyStyle(imgPlaceholder);
        }
        return applyStyle(imgPlaceholder);
      };

      self.getType = function(content) {
        if (content.type) {
          return content.type;
        } else if (content.name) {
          return 'track';
        } else if (content.start_date) {
          return 'event';
        } else if (content.package_duration || content.typical_time) {
          return 'scorm';
        } else if (content.published) {
          return 'presentation';
        } else if (content.instructors) {
          return 'imported_content';
        } else {
          return 'article';
        }
      };

      self.trimHtml = function(item) {
        var text = item.description || item.content;
        if (!text) {
          self.trackTrim = ' ';
          return;
        }

        var div = document.createElement("div");
        div.innerHTML = text;
        var newText = div.textContent || div.innerText || "";

        var trimTo = 90;
        var addDots = false;
        if (newText.length > 90) {
          addDots = true;
        }

        newText = $filter('limitTo')(newText, trimTo);
        self.trackTrim = addDots ? newText + '...' : newText;
      };

      self.formatDate = function(date) {
        if (!date) {
          return self.translations['modules.smartcard.tbd'];
        }
        return moment(date).format('M/DD/YY');
      };

      self.goToMe = function() {
        if ($scope.contentType === 'poll') {
          return;
        }

        if ($scope.contentType === 'user') {
          if ($scope.userClick) {
            $scope.userClick({user: self.content._id});
            return;
          }
          Application.navigation.goTo('/profile/' + self.content._id);
          return;
        }
        self.contentType = self.contentType === 'resource' ? 'track' : self.contentType;
        var type = self.contentType === 'scorm' ? self.contentType : self.contentType === 'imported_content' ? 'imported-content' : $scope.contentType === 'multi_session_workshop' ? 'multi-session-workshops' : $scope.contentType + 's';
        if ($scope.searchTerm && self.content._id && self.contentType) {
          var searchAnalyticsType = self.contentType === 'scorm' ? 'scorm-content' :  self.contentType === 'multi_session_workshop' ? 'workshop' : self.contentType;
          var searchAnalyticsBody = {search_term: $scope.searchTerm, selected_content: self.content._id, content_type: searchAnalyticsType};
          Analyze.record({resource: 'search'}, searchAnalyticsBody);
        }
        Application.navigation.goTo('/view/' + type + '/' + self.content._id);
      };

      self.justification = {
        isLeft: function() {
          if (!self.content) {
            return true;
          }
          if (self.first && !self.content.featured_justification || self.first && self.content.featured_justification === 'left') {
            return true;
          }
          if (!self.first && !self.content.cover_justification || !self.first && self.content.cover_justification === 'left') {
            return true;
          }
          return false;
        },
        isCenter: function() {
          if (!self.content) {
            return false;
          }
          if (self.first && self.content.featured_justification === 'center') {
            return true;
          }
          if (!self.first && self.content.cover_justification === 'center') {
            return true;
          }
          return false;
        },
        isRight: function() {
          if (!self.content) {
            return false;
          }
          if (self.first && self.content.featured_justification === 'right') {
            return true;
          }
          if (!self.first && self.content.cover_justification === 'right') {
            return true;
          }
          return false;
        },
      };

      self.poll = {
        init: function(poll) {
          var userId = Authorization.getAuthToken().user._id;
          if (poll.users_responded) {
            this.totalVotes = poll.users_responded.length;
            if (poll.expiration) {
              this.remaining = moment(new Date(poll.expiration)).toNow(true);
            }
            if (poll.users_responded.indexOf(userId) !== -1) {
              this.parseResults(poll);
              this.hasTaken = true;
            }
          }
        },
        totalVotes: 0,
        remaining: null,
        data: null,
        labels: null,
        parseResults: function(poll) {
          this.results = {};

          var resultOptions = {
            a: 'results_a',
            b: 'results_b',
            c: 'results_c',
            d: 'results_d',
            e: 'results_e'
          };
          for (var i = 0; i < self.content.answers.length; i++) {
            var resultName = resultOptions[self.content.answers[i].value];
            if (!resultName || !poll[resultName]) {
              continue;
            };
            var label = self.content.answers[i].label;
            var value = poll[resultName].length;
            var valueAsNumber = parseInt(value);
            var percent = Math.floor(valueAsNumber / (this.totalVotes / 100));
            this.results[i] = {
              "label": label,
              "value": value,
              "percent": percent
            };
          }
        },
        selection: null,
        hasTaken: false,
        stopProp: function(evt) {
          evt.stopPropagation();
        },
        inputClick: function(value) {
          var input = document.getElementById('answer' + value);
          setTimeout(function() {
            input.click();
          }, 1);
        },
        chooseAnswer: function(value) {
          this.selection = value;
        },
        submit: function() {
          var userId = Authorization.getAuthToken().user._id;
          if (!userId) {
            return;
          }
          Polls.respond({subresource: self.content._id, userid: userId}, {answer: this.selection}).$promise
          .then(function(response) {
            var toParse = self.content;
            if (response.status === 'success' && response.poll.show_results) {
              self.content.users_responded.push(userId);
              self.content['results_' + self.poll.selection].push(userId);
              if (response.poll.users_responded) {
                self.poll.totalVotes = response.poll.users_responded.length;
              }
              toParse = response.poll;
            }
            self.poll.parseResults(toParse);
            self.poll.hasTaken = true;
            Application.messaging.addMessage({type: 'success', duration: 4, text: self.translations['modules.smartcard.poll_response']});
          }).catch(function(error) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['modules.smartcard.poll_issue']});
          });
        }
      };
      var metaWatch;
      self.initialize = function () {
        self.loading = true;
        if (!$scope.fullData && $scope.contentId) {
          if ($scope.contentType === 'user') {
            return;
          }
          // Get data when none is passed in
          getContent($scope.contentType, $scope.contentId)
          .then(function(data) {
            self.content = data;
            self.contentType = $scope.contentType;
            if ($scope.contentType === 'poll') {
              self.poll.init(data);
            }
            self.loading = false;
          }, function(err) {
            self.loading = false;
          });

          idWatch();
          dataWatch();
        } else {
          if ($scope.metaData) {
            $scope.metaData.views = $scope.metaData.views > 0 ? $scope.metaData.views : 0;
            $scope.metaData.likes = $scope.metaData.likes > 0 ? $scope.metaData.likes : 0;
            $scope.metaData.shares = $scope.metaData.shares > 0 ? $scope.metaData.shares : 0;
          } else if (!metaWatch) {
            metaWatch = $scope.$watch('metaData', function(newVal, oldVal) {
              if (newVal && typeof newVal.views === 'number') {
                $scope.metaData.views = $scope.metaData.views > 0 ? $scope.metaData.views : 0;
                $scope.metaData.likes = $scope.metaData.likes > 0 ? $scope.metaData.likes : 0;
                $scope.metaData.shares = $scope.metaData.shares > 0 ? $scope.metaData.shares : 0;
                metaWatch();
                metaWatch = true;
              };
            }, true);
          }
          // use passed in data when available.
          self.content = $scope.fullData;
          self.contentType = $scope.contentType;
          if (self.contentType === 'user') {
            return;
          }
          if (!self.contentType) {
            self.contentType = self.getType(self.content);
            $scope.contentType = self.contentType
          }
          if (self.contentType === 'poll') {
            self.poll.init($scope.fullData);
          }
          if (self.contentType === 'track' || self.contentType === 'event') {
            self.trimHtml(self.content);
          }

          if (self.contentType === 'track' && self.content.resource) {
            self.contentType = 'resource';
          }

          idWatch();
          dataWatch();
        }
      };

      var dataWatch = $scope.$watch('fullData', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.initialize();
      }, true);

      var idWatch = $scope.$watch('contentId', function(newVal, oldVal) {
        if (!newVal || newVal === oldVal) {
          return;
        }
        self.initialize();
      });

      if ($scope.fullData || $scope.contentId) {
        self.initialize();
      }
      if ($scope.previewWatch) {
        $scope.$watch('fullData', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          self.initialize();
        }, true);
      }

      self.lengthTarget = function(target, max, obj){
        var breaksMax = false;
        if (obj !== undefined){
          obj.forEach(function(item){
            var valuelength = item[target].length;
            valuelength > max ? breaksMax = true : '';
          });
          return breaksMax;
        }
        return breaksMax;
      };

      $translate(['modules.smartcard.tbd', 'modules.smartcard.poll_response', 'modules.smartcard.poll_issue']).then(function(translations) {
        self.translations = translations;
      })

    }],
    controllerAs: 'cardData'
  };
}]);
